import React from 'react';

const KIND_CLASS = {
  Product: 'gdwd-badge--product',
  Platform: 'gdwd-badge--platform',
  Mobile: 'gdwd-badge--mobile',
  Collaboration: 'gdwd-badge--collab',
  Wip: 'gdwd-badge--wip',
};

export default function Badge({ kind, children }) {
  return <span className={`gdwd-badge ${KIND_CLASS[kind] || 'gdwd-badge--product'}`}>{children}</span>;
}
